import InquiryForm from "@/components/InquiryForm";

export default function Inquire() {
  return (
    <div className="max-w-[1100px] mx-auto px-6 sm:px-10 py-20 fade-up" data-testid="inquire-page">
      <p className="plaque-label">Correspondence</p>
      <h1 className="font-serif-display font-light text-5xl sm:text-7xl leading-[0.95] mt-4 max-w-3xl">
        Write to the artist.
      </h1>
      <p className="text-zinc-400 mt-6 max-w-2xl text-lg">
        Available works, commissions, private viewings — all begin with a quiet message.
      </p>

      <div className="grid md:grid-cols-12 gap-16 mt-16">
        <div className="md:col-span-7">
          <InquiryForm />
        </div>
        <aside className="md:col-span-4 md:col-start-9 space-y-8">
          <div>
            <p className="plaque-label mb-3">Response Time</p>
            <p className="text-zinc-300 text-sm">Inquiries are answered within 3–5 days.</p>
          </div>
          <div>
            <p className="plaque-label mb-3">Privacy</p>
            <p className="text-zinc-300 text-sm">Your message is read only by the artist.</p>
          </div>
        </aside>
      </div>
    </div>
  );
}
